<div class="kat-container">

  <!-- HEADER -->
  <div class="page-header">
    <div class="header-titles">
      <h1 class="page-title">Kategorien &amp; Prüfpunkte</h1>
      <span class="page-sub">
        Vorlagen für die Inbetriebnahme.
      </span>
    </div>

    <button mat-raised-button color="primary" type="button" *ngIf="!formOpen" (click)="neueKategorie()">
      <mat-icon>add</mat-icon>
      Neue Kategorie
    </button>
  </div>


  <!-- KATEGORIE-FORMULAR -->
  <mat-card class="form-card" *ngIf="formOpen">
    <mat-card-content>

      <h2 class="form-title">
        {{ editId == null ? 'Neue Kategorie' : 'Kategorie bearbeiten' }}
      </h2>

      <div class="form-grid">
        <mat-form-field appearance="outline">
          <mat-label>Name</mat-label>
          <input matInput [(ngModel)]="form.name" [disabled]="saving" placeholder="z.B. Messgerät">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Beschreibung (optional)</mat-label>
          <input matInput [(ngModel)]="form.beschreibung" [disabled]="saving">
        </mat-form-field>



        <div class="form-toggle">
          <mat-slide-toggle [(ngModel)]="form.isActive" [disabled]="saving">
            Aktiv
          </mat-slide-toggle>
          <span class="toggle-hint">
            Inaktive Kategorien sind für neue Messstellen nicht wählbar.
          </span>
        </div>
      </div>

      <p class="form-error" *ngIf="formError">
        <mat-icon>error_outline</mat-icon>
        {{ formError }}
      </p>

      <div class="form-actions">
        <button mat-button type="button" [disabled]="saving" (click)="abbrechen()">Abbrechen</button>
        <button mat-raised-button color="primary" type="button" [disabled]="!formGueltig || saving"
          (click)="speichern()">
          <mat-spinner diameter="18" *ngIf="saving"></mat-spinner>
          <span *ngIf="!saving">Speichern</span>
        </button>
      </div>

    </mat-card-content>
  </mat-card>


  <!-- ZUSTÄNDE -->
  <div class="loading" *ngIf="isLoading">
    <mat-spinner diameter="40"></mat-spinner>
  </div>

  <mat-card class="hint-card" *ngIf="loadError">
    <mat-card-content>{{ loadError }}</mat-card-content>
  </mat-card>

  <mat-card class="hint-card" *ngIf="!isLoading && !loadError && kategorien.length === 0">
    <mat-card-content>
      Es ist noch keine Kategorie angelegt. Über „Neue Kategorie" entsteht die erste
      Prüfstruktur; danach lassen sich Abschnitte und Prüfpunkte hinzufügen.
    </mat-card-content>
  </mat-card>


  <!-- KATEGORIEN -->
  <mat-card class="kat-card" *ngFor="let kategorie of kategorien; let i = index; trackBy: trackByKategorie"
    [class.kat-inaktiv]="!kategorie.isActive">
    <mat-card-content>

      <!-- Kopf -->
      <div class="kat-head">
        <button mat-icon-button type="button" (click)="toggle(kategorie)"
          [matTooltip]="istOffen(kategorie) ? 'Zuklappen' : 'Aufklappen'">
          <mat-icon>{{ istOffen(kategorie) ? 'expand_less' : 'expand_more' }}</mat-icon>
        </button>

        <span class="kat-farbe" *ngIf="kategorie.color" [style.background]="kategorie.color"></span>

        <div class="kat-titel-block">

          <!-- Normale Ansicht -->
          <ng-container *ngIf="!istInlineEdit('kategorie', kategorie.id)">
            <span class="kat-titel">{{ kategorie.name }}</span>

            <span class="kat-meta">
              {{ kategorie.abschnitte.length }} Abschnitte ·
              {{ punkteGesamt(kategorie) }} Prüfpunkte

              <ng-container *ngIf="kategorie.verwendetVonMessstellen > 0">
                · {{ kategorie.verwendetVonMessstellen }} Messstellen
              </ng-container>
            </span>

            <span class="kat-beschreibung" *ngIf="kategorie.beschreibung">
              {{ kategorie.beschreibung }}
            </span>
          </ng-container>

          <!-- Bearbeitungsmodus -->
          <div class="inline-kategorie" *ngIf="istInlineEdit('kategorie', kategorie.id)"
            (click)="$event.stopPropagation()">

            <input class="inline-input inline-titel" type="text" [(ngModel)]="inlineName" [disabled]="inlineSaving"
              (keydown.enter)="inlineSpeichern()" (keydown.escape)="inlineAbbrechen()" placeholder="Kategoriename"
              autofocus>

            <input class="inline-input inline-beschreibung" type="text" [(ngModel)]="inlineBeschreibung"
              [disabled]="inlineSaving" (keydown.enter)="inlineSpeichern()" (keydown.escape)="inlineAbbrechen()"
              placeholder="Beschreibung (optional)">

            <span class="inline-error" *ngIf="inlineError">
              {{ inlineError }}
            </span>

            <div class="inline-actions">
              <button mat-icon-button type="button" color="primary" matTooltip="Speichern"
                [disabled]="inlineSaving || !inlineName.trim()" (click)="inlineSpeichern()">
                <mat-icon>check</mat-icon>
              </button>

              <button mat-icon-button type="button" matTooltip="Abbrechen" [disabled]="inlineSaving"
                (click)="inlineAbbrechen()">
                <mat-icon>close</mat-icon>
              </button>
            </div>

          </div>
        </div>

        <span class="chip-inaktiv" *ngIf="!kategorie.isActive">inaktiv</span>

        <div class="kat-actions">
          <button mat-icon-button type="button" [disabled]="busy || i === 0"
            (click)="verschiebeKategorie(kategorie, -1)" matTooltip="Nach oben">
            <mat-icon>arrow_upward</mat-icon>
          </button>
          <button mat-icon-button type="button" [disabled]="busy || i === kategorien.length - 1"
            (click)="verschiebeKategorie(kategorie, 1)" matTooltip="Nach unten">
            <mat-icon>arrow_downward</mat-icon>
          </button>

          <button mat-icon-button type="button" [disabled]="busy" (click)="toggleAktiv(kategorie)"
            [matTooltip]="kategorie.isActive ? 'Deaktivieren' : 'Wieder aktivieren'">
            <mat-icon>{{ kategorie.isActive ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>

          <button mat-icon-button type="button" [disabled]="busy || inlineSaving || inlineEdit !== null" (click)="bearbeiten(kategorie)" matTooltip="Bearbeiten">
            <mat-icon>edit</mat-icon>
          </button>

          <button mat-icon-button type="button" matTooltip="Kategorie duplizieren"
            [disabled]="dupliziertKategorieId === kategorie.id" (click)="
    $event.stopPropagation();
    kategorieDuplizieren(kategorie)
  ">

            <mat-spinner *ngIf="dupliziertKategorieId === kategorie.id" diameter="20">
            </mat-spinner>

            <mat-icon *ngIf="dupliziertKategorieId !== kategorie.id">
              content_copy
            </mat-icon>

          </button>

          <button mat-icon-button color="warn" type="button" [disabled]="busy" (click)="loeschenKategorie(kategorie)"
            [matTooltip]="kategorie.kannGeloeschtWerden
                    ? 'Löschen'
                    : 'Wird verwendet – nur Deaktivieren möglich'">
            <mat-icon>delete_outline</mat-icon>
          </button>
        </div>
      </div>


      <!-- Struktur -->
      <div class="kat-body" *ngIf="istOffen(kategorie)">

        <p class="empty-hint" *ngIf="kategorie.abschnitte.length === 0">
          Noch kein Abschnitt. Ein Abschnitt gruppiert die Prüfpunkte,
          z.&nbsp;B. „Elektrische Daten" oder „Mechanik".
        </p>

        <div class="abschnitt"
          *ngFor="let abschnitt of kategorie.abschnitte; let ai = index; trackBy: trackByAbschnitt">

          <div class="abschnitt-head">
            <span class="abschnitt-nummer">{{ ai + 1 }}</span>
            <!-- Normale Ansicht -->
            <span class="abschnitt-name" *ngIf="!istInlineEdit('abschnitt', abschnitt.id)">
              {{ abschnitt.name }}
            </span>

            <!-- Bearbeitungsmodus -->
            <div class="inline-zeile" *ngIf="istInlineEdit('abschnitt', abschnitt.id)">

              <input class="inline-input" type="text" [(ngModel)]="inlineName" [disabled]="inlineSaving"
                (keydown.enter)="inlineSpeichern()" (keydown.escape)="inlineAbbrechen()" autofocus>

              <button mat-icon-button color="primary" type="button" [disabled]="inlineSaving || !inlineName.trim()"
                (click)="inlineSpeichern()" matTooltip="Speichern">
                <mat-icon>check</mat-icon>
              </button>

              <button mat-icon-button type="button" [disabled]="inlineSaving" (click)="inlineAbbrechen()"
                matTooltip="Abbrechen">
                <mat-icon>close</mat-icon>
              </button>

              <span class="inline-error" *ngIf="inlineError">
                {{ inlineError }}
              </span>

            </div>
            <span class="abschnitt-anzahl">{{ abschnitt.vorlagen.length }}</span>

            <div class="abschnitt-actions">
              <button mat-icon-button type="button" [disabled]="busy || ai === 0"
                (click)="verschiebeAbschnitt(kategorie, abschnitt, -1)" matTooltip="Nach oben">
                <mat-icon>arrow_upward</mat-icon>
              </button>
              <button mat-icon-button type="button" [disabled]="busy || ai === kategorie.abschnitte.length - 1"
                (click)="verschiebeAbschnitt(kategorie, abschnitt, 1)" matTooltip="Nach unten">
                <mat-icon>arrow_downward</mat-icon>
              </button>
              <button mat-icon-button type="button" [disabled]="busy || inlineSaving || inlineEdit !== null" (click)="abschnittUmbenennen(abschnitt)"
                matTooltip="Umbenennen">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button color="warn" type="button" [disabled]="busy"
                (click)="abschnittLoeschen(abschnitt)" matTooltip="Abschnitt löschen">
                <mat-icon>delete_outline</mat-icon>
              </button>
            </div>
          </div>

          <!-- Prüfpunkte -->
          <div class="punkt" *ngFor="let vorlage of abschnitt.vorlagen; let vi = index; trackBy: trackByVorlage">

            <mat-icon class="punkt-icon">radio_button_unchecked</mat-icon>
            <!-- Normale Ansicht -->
            <span class="punkt-text" *ngIf="!istInlineEdit('punkt', vorlage.id)">
              {{ vorlage.bezeichnung }}
            </span>

            <!-- Bearbeitungsmodus -->
            <div class="inline-zeile" *ngIf="istInlineEdit('punkt', vorlage.id)">

              <input class="inline-input" type="text" [(ngModel)]="inlineName" [disabled]="inlineSaving"
                (keydown.enter)="inlineSpeichern()" (keydown.escape)="inlineAbbrechen()" autofocus>

              <button mat-icon-button color="primary" type="button" [disabled]="inlineSaving || !inlineName.trim()"
                (click)="inlineSpeichern()" matTooltip="Speichern">
                <mat-icon>check</mat-icon>
              </button>

              <button mat-icon-button type="button" [disabled]="inlineSaving" (click)="inlineAbbrechen()"
                matTooltip="Abbrechen">
                <mat-icon>close</mat-icon>
              </button>

              <span class="inline-error" *ngIf="inlineError">
                {{ inlineError }}
              </span>

            </div>

            <span class="punkt-verwendet" *ngIf="vorlage.verwendetInPruefpunkten > 0"
              matTooltip="So oft bereits an Messstellen ausgeprägt">
              {{ vorlage.verwendetInPruefpunkten }}×
            </span>

            <div class="punkt-actions">
              <button mat-icon-button type="button" [disabled]="busy || vi === 0"
                (click)="verschiebePunkt(abschnitt, vorlage, -1)" matTooltip="Nach oben">
                <mat-icon>arrow_upward</mat-icon>
              </button>
              <button mat-icon-button type="button" [disabled]="busy || vi === abschnitt.vorlagen.length - 1"
                (click)="verschiebePunkt(abschnitt, vorlage, 1)" matTooltip="Nach unten">
                <mat-icon>arrow_downward</mat-icon>
              </button>

              <button mat-icon-button type="button" [disabled]="busy" [matMenuTriggerFor]="verschiebeMenu"
                matTooltip="In anderen Abschnitt verschieben" *ngIf="kategorie.abschnitte.length > 1">
                <mat-icon>swap_horiz</mat-icon>
              </button>

              <mat-menu #verschiebeMenu="matMenu">
                <ng-container *ngFor="let ziel of kategorie.abschnitte">
                  <button mat-menu-item type="button" *ngIf="ziel.id !== abschnitt.id"
                    (click)="punktVerschiebenNach(vorlage, ziel.id)">
                    {{ ziel.name }}
                  </button>
                </ng-container>
              </mat-menu>

              <button mat-icon-button type="button" [disabled]="busy || inlineSaving || inlineEdit !== null" (click)="punktUmbenennen(vorlage)"
                matTooltip="Umbenennen">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button color="warn" type="button" [disabled]="busy" (click)="punktLoeschen(vorlage)"
                matTooltip="Löschen">
                <mat-icon>delete_outline</mat-icon>
              </button>
            </div>
          </div>

          <!-- Prüfpunkt hinzufügen -->
          <div class="neu-zeile">
            <mat-form-field appearance="outline" class="neu-feld">
              <mat-label>Prüfpunkt hinzufügen</mat-label>
              <input matInput [(ngModel)]="neuerPunkt[abschnitt.id]" [disabled]="busy"
                (keyup.enter)="punktHinzufuegen(abschnitt)" placeholder="z.B. Anschluss">
            </mat-form-field>

            <button mat-stroked-button type="button" [disabled]="busy || !(neuerPunkt[abschnitt.id] || '').trim()"
              (click)="punktHinzufuegen(abschnitt)">
              <mat-icon>add</mat-icon>
            </button>
          </div>

        </div>


        <!-- Abschnitt hinzufügen -->
        <div class="neu-zeile neu-abschnitt">
          <mat-form-field appearance="outline" class="neu-feld">
            <mat-label>Abschnitt hinzufügen</mat-label>
            <input matInput [(ngModel)]="neuerAbschnitt[kategorie.id]" [disabled]="busy"
              (keyup.enter)="abschnittHinzufuegen(kategorie)" placeholder="z.B. Elektrische Daten">
          </mat-form-field>

          <button mat-flat-button color="primary" type="button"
            [disabled]="busy || !(neuerAbschnitt[kategorie.id] || '').trim()" (click)="abschnittHinzufuegen(kategorie)">
            <mat-icon>add</mat-icon>
            Abschnitt
          </button>
        </div>

      </div>

    </mat-card-content>
  </mat-card>

</div>